import { IconGitpod } from "@/assets/icons/geist/IconGitpod";
import { Button } from "@/components/flexkit/Button";
import { Text } from "@/components/podkit/typography/Text";
import { useDesktop } from "@/hooks/use-desktop";
import { type FC } from "react";

export const AccountDeletedPage: FC = () => {
    const desktop = useDesktop();
    return (
        <div data-testid="account-deleted-page" className="flex h-full flex-col items-center justify-center gap-6">
            <div className="flex flex-col items-center gap-1">
                <IconGitpod size="lg" className="size-10 text-content-orange" />
                <Text className="text-xl text-content-secondary">Your account has been deleted</Text>
            </div>
            {desktop.isDesktop ? null : (
                <Button variant="primary" asChild>
                    <a href="https://www.gitpod.io">Return to Gitpod homepage</a>
                </Button>
            )}
        </div>
    );
};
